import { DateRangeCalendarTexts } from "@smartsuite/react-ui/lib/components/fields/Date/DateRange/DateRangeCalendar/DateRangeCalendar.constants";
import { defineMessages } from "react-intl";

import { $t } from "../../../utils/intl";

export const dateRangeTexts = defineMessages({
  title: {
    defaultMessage: "Select Date Range",
    id: "KAX9q+",
  },
  startTitle: {
    defaultMessage: "Start Date",
    id: "QirE3M",
  },
  startLabel: {
    defaultMessage: "Add Start Date",
    id: "uhnnlE",
  },
  cancelText: {
    defaultMessage: "Cancel",
    id: "47FYwb",
  },
  doneText: {
    defaultMessage: "Done",
    id: "JXdbo8",
  },
  endTitle: {
    defaultMessage: "End Date",
    id: "T4GOiX",
  },
  endLabel: {
    defaultMessage: "Add End Date",
    id: "vqBBHt",
  },
  timePlaceholder: {
    defaultMessage: "Add Time",
    id: "s2gfPU",
  },
  placeholder: {
    defaultMessage: "Select Date Range",
    id: "KAX9q+",
  },
  triggerAriaLabel: {
    defaultMessage: "Select date range",
    id: "qp/RxH",
  },
  removeDateAriaLabel: {
    defaultMessage: "Remove Date",
    id: "I7vzZH",
  },
  oneDayText: {
    defaultMessage: "1 day",
    id: "+7PjfV",
  },
  daysCountText: {
    defaultMessage: "{count} days",
    id: "gcYCT/",
  },
});

export const texts: DateRangeCalendarTexts = {
  title: $t(dateRangeTexts.title),
  cancelButton: $t(dateRangeTexts.cancelText),
  doneButton: $t(dateRangeTexts.doneText),
  header: {
    startTitle: $t(dateRangeTexts.startTitle),
    endTitle: $t(dateRangeTexts.endTitle),
    startLabel: $t(dateRangeTexts.startLabel),
    endLabel: $t(dateRangeTexts.endLabel),
    timePlaceholder: $t(dateRangeTexts.timePlaceholder),
  },
};
